// extracted by mini-css-extract-plugin
export var addButton = "_jn-0";
export var border = "_jn-8";
export var check = "_jn-h";
export var danger = "_jn-6";
export var dropdownContainer = "_jn-1";
export var editModalBody = "_jn-j";
export var footerContainer = "_jn-i";
export var fullWidth = "_jn-a";
export var hide = "_jn-9";
export var icon = "_jn-3";
export var input = "_jn-7";
export var inputFlex = "_jn-b";
export var inputWrapper = "_jn-c";
export var manualFocus = "_jn-5";
export var optionButton = "_jn-4";
export var pillWrapper = "_jn-e";
export var pointer = "_jn-2";
export var showOverflow = "_jn-f";
export var tagsFlex = "_jn-d";
export var xButton = "_jn-g";